import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { productList } from "./productList.ts";

// const products1 = Array.from({ length: 5 }, (_, i) => ({
//   id: i + 1,
//   name: `Product ${i + 1}`,
//   image: require(`../assets/images/products/product${i + 1}.png`),
// }));

export const Products = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="products_section" id="products">
      <h1>Our Products</h1>
      <hr></hr>
      <div className="products-slider-wrapper">
        <Slider {...settings}>
          {productList.map((product) => (
            <div key={product.id} className="product-card">
              <img src={product.image} alt={product.name} />
              <h4>{product.name}</h4>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
